export enum LadingStatus {
    GdKhoiTao = 1,
    DuyetHoan = 2,
    DangHoan = 3,
    HoanThanhCong = 4,
    NhapKhoGiaoHang = 5,
    NhapKhoChuyenVung = 6,
    DangChuyenVung = 7,
    LayHangThanhCong = 8,
    DiPhat = 9,
    ChoLayHang = 10,
    ChoCapNhat = 11,
    LayHangThanhCongChoCapNhat = 12,
    PhanCongPhat = 13,
    PhatThanhCong = 14,
    PhatLai = 15,
    DonSuCo = 16,
    NhapKhoChoCapNhat = 17,
    NhapKhoChuyenHoan = 18,
    ChuyenTiep = 19,
    DuyetChuyenTiep = 20,
    DiHoan = 21,
    PhanCongHoan = 22,
    Reject = 111
}
